import { helpers } from "vuelidate/lib/validators";

export const alphaNumUpperSymbol = helpers.regex(
  "alphaNumUpperSymbol",
  /^[A-Z0-9!@#$%^&*()\-_+=[\]{}|;:'",.<>?~`]*$/
);

export const ALLOWED_KEY_PATTERN = /^[A-Za-z0-9!@#$%^&*()\-_+=[\]{}|;:'",.<>?~`]$/;

export function preventInvalidKey(event) {
  if (!ALLOWED_KEY_PATTERN.test(event.key)) {
    event.preventDefault();
  }
}

export function formatCodeInput(value) {
  return value
    .toUpperCase()
    .trim()
    .replace(/[^A-Z0-9!@#$%^&*()\-_+=[\]{}|;:'",.<>?~`]/g, "");
}
